import React, { useState } from 'react'
import { Drawer, IconButton } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import Header from '../components/Header/Header'
import Aside from '../components/Aside/Aside'
import Section from '../components/Section/Section'
import AlertPOP from './AlertPOP'
import { ThemeProvider } from '@mui/material/styles'
import dashboardTheme from './dashboardTheme'
import './Dashboard.css'



function Main() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <ThemeProvider theme={dashboardTheme}>
    <div className="main-con grid fin-dashboard">
    <a className="dashboard-skip" href="#dashboard-content">Skip to dashboard content</a>
    <AlertPOP/>

    <div className="dashboard-mobile-bar"><IconButton aria-label="Open navigation" aria-expanded={menuOpen} onClick={()=>setMenuOpen(true)}><MenuIcon/></IconButton><span>Fityanul Islam</span></div>
    <Drawer open={menuOpen} onClose={()=>setMenuOpen(false)} sx={{display:{xs:'block',md:'none'}, '& .MuiDrawer-paper':{width:280,maxWidth:'85vw'}}}><IconButton aria-label="Close navigation" onClick={()=>setMenuOpen(false)} sx={{alignSelf:'flex-end'}}><CloseIcon/></IconButton><div className="dashboard-mobile-navigation" onClick={event=>{if(event.target.closest('nav button, nav a'))setMenuOpen(false);}}><Aside/></div></Drawer>
    <Header/>
     
    <Aside/>
  
    <Section/>
    
    </div>
    </ThemeProvider>
  )
}

export default Main